import { render, staticRenderFns } from "./BtnExcluirDetalheFase.vue?vue&type=template&id=53c7990b&"
import script from "./BtnExcluirDetalheFase.vue?vue&type=script&lang=js&"
export * from "./BtnExcluirDetalheFase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports